import React from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import './CompMarquee.css'; // Assuming you have a CSS file for styling

const CompMarquee = (props) => {
    const className = props.height === "full" ? "uxi-marquee-bg-full" : "uxi-marquee-bg";

    return (
        <div className={className}>
            <div><Typography variant="h1" style={{ color: 'white', fontFamily: 'ethnocentric' }}>{props.title}</Typography></div>
            <div><Typography style={{ color: 'white', fontSize: '20px' }}>{props.subTitle}</Typography></div>
        </div>
    );
};

export default CompMarquee;
